import { gql } from 'graphql-request'

export const EXPORT_STORY_DASHBOARD = gql`
  query ExportStoryDashboard($startDate: DateTime!, $endDate: DateTime!) {
    exportStoryDashboard(startDate: $startDate, endDate: $endDate)
  }
`
